

export const LOGIN = 'login';
export const LOGOUT = 'logout';
export const TITLE = 'title';
export const LANGUAGE = 'language';
export const USER = 'user';
export const LEVEL = 'level';

//渠道
export const CHANNEL = 'channel';
export const ADDCRUMBS = 'ADDCRUMBS' //面包屑列表
export const CURRENTNAME = 'CURRENTNAME' // 面包屑当前页名称
export const AREAID = 'AREAID' // 区域id
export const ORDERTYPE = 'ORDERTYPE' // 订单类型列表
export const ORGID = 'ORGID' //公司详情id
export const BASICINFO = 'BASICINFO'
export const ALIPAYHTML = 'ALIPAYHTML'
export const LEADERINFO = 'LEADERINFO'
export const ISONLINE = 'ISONLINE'
export const COUNTRYCODE = 'COUNTRYCODE' // 国家简称
export const COUNTRYNAME = 'COUNTRYNAME' // 国家名称
export const SETUNREADMSG = 'SETUNREADMSG' // 未读消息




// WEBPACK FOOTER //
// ./src/store/types.js